import { render, staticRenderFns } from "./SanFranciscoSyncopeSevere.vue?vue&type=template&id=622c848a&scoped=true&"
import script from "./SanFranciscoSyncopeSevere.vue?vue&type=script&lang=js&"
export * from "./SanFranciscoSyncopeSevere.vue?vue&type=script&lang=js&"
import style0 from "./SanFranciscoSyncopeSevere.vue?vue&type=style&index=0&id=622c848a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622c848a",
  null
  
)

export default component.exports